import {
  CUSTOMER_ITEMS,
  CUSTOMER_MARKET,
  CUSTOMER_REQUESTS,
  CUSTOMER_SUBSCRIPTIONS,
  CUSTOMER_WALLET,
  GET_CUSTOMER, GET_CUSTOMER_DETAILS,
} from '../actionTypes';

const initialState = {
  customers: [],
  isLoading: false,
  error: false,
  message: '',
  selectedCustomer: {},
  customerOverview: {},
  totalPage: 1,
  currentPage: 1,

  isLoadingItems: false,
  customerItems: [],
  customerItemsMeta: {
    totalPage: 1,
    currentPage: 1,
  },

  isLoadingRequests: false,
  customerRequests: [],
  customerRequestsMeta: {
    totalPage: 1,
    currentPage: 1,
  },

  isLoadingSubs: false,
  customerSubs: [],
  customerSubsMeta: {
    totalPage: 1,
    currentPage: 1,
  },

  isLoadingWallet: false,
  customerWallet: [],
  customerWalletMeta: {
    totalPage: 1,
    currentPage: 1,
  },

  isLoadingMarket: false,
  customerMarket: [],
  customerMarketMeta: {
    totalPage: 1,
    currentPage: 1,
  },
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_CUSTOMER}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_CUSTOMER}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_CUSTOMER}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        customers: payload.data.data?.data || [],
        customerOverview: payload.data.data?.customer_overview || {},
        totalPage: payload.data.data?.total_page,
        currentPage: payload.data.data?.current_page,
      };

    case `${GET_CUSTOMER_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        selectedCustomer: {},
      };
    case `${GET_CUSTOMER_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_CUSTOMER_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedCustomer: payload.data.data || [],
      };

    case `${CUSTOMER_ITEMS}_PENDING`:
      return {
        ...state,
        isLoadingItems: true,
        error: false,
      };
    case `${CUSTOMER_ITEMS}_REJECTED`:
      return {
        ...state,
        isLoadingItems: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CUSTOMER_ITEMS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        customerItems: payload.data.data || [],
        customerItemsMeta: {
          totalPage: payload.data?.total_page,
          currentPage: payload.data?.current_page,
          total: payload.data?.total,
        },
        isLoadingItems: false,
      };

    case `${CUSTOMER_REQUESTS}_PENDING`:
      return {
        ...state,
        isLoadingRequests: true,
        error: false,
      };
    case `${CUSTOMER_REQUESTS}_REJECTED`:
      return {
        ...state,
        isLoadingRequests: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CUSTOMER_REQUESTS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        customerRequests: payload.data.data || [],
        customerRequestsMeta: {
          totalPage: payload.data?.total_page,
          currentPage: payload.data?.current_page,
          total: payload.data?.total,
        },
        isLoadingRequests: false,
      };

    case `${CUSTOMER_SUBSCRIPTIONS}_PENDING`:
      return {
        ...state,
        isLoadingSubs: true,
        error: false,
      };
    case `${CUSTOMER_SUBSCRIPTIONS}_REJECTED`:
      return {
        ...state,
        isLoadingSubs: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CUSTOMER_SUBSCRIPTIONS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        customerSubs: payload.data.data || [],
        customerSubsMeta: {
          totalPage: payload.data?.total_page,
          currentPage: payload.data?.current_page,
          total: payload.data?.total,
        },
        isLoadingSubs: false,
      };

    case `${CUSTOMER_WALLET}_PENDING`:
      return {
        ...state,
        isLoadingWallet: true,
        error: false,
      };
    case `${CUSTOMER_WALLET}_REJECTED`:
      return {
        ...state,
        isLoadingWallet: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CUSTOMER_WALLET}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        customerWallet: payload.data.data || [],
        customerWalletMeta: {
          totalPage: payload.data?.total_page,
          currentPage: payload.data?.current_page,
          total: payload.data?.total,
        },
        isLoadingWallet: false,
      };

    case `${CUSTOMER_MARKET}_PENDING`:
      return {
        ...state,
        isLoadingMarket: true,
        error: false,
      };
    case `${CUSTOMER_MARKET}_REJECTED`:
      return {
        ...state,
        isLoadingMarket: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CUSTOMER_MARKET}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        customerMarket: payload.data.data || [],
        customerMarketMeta: {
          totalPage: payload.data?.total_page,
          currentPage: payload.data?.current_page,
          total: payload.data?.total,
        },
        isLoadingMarket: false,
      };

    default:
      return state;
  }
}
